import React from 'react';
import styles from './section.module.css';

const VideoPopup = ({ videoPopupRef, handleCloseClick,popupVideoRef,currentVideoSrc }) => {

    return (
       <>
       <div className={styles.videoPopup} ref={videoPopupRef}>
                                       <button className={styles.closeButton} onClick={handleCloseClick}>
                                           ✖
                                       </button>
                                       <div className={styles.videoPopupContent}>
                                           <video
                                           className={styles.videoPop}
                                               ref={popupVideoRef}
                                               controls
                                               autoPlay
                                               src={currentVideoSrc}  // Replace with your video URL
                                           />
                                          {/*  <button onClick={handleCloseClick}>Close</button> */}
                                       </div>
                                   </div>
       </>
    );
};

export default VideoPopup;
